/* eslint-disable no-param-reassign */

import AiMessage from './ai-message';
import AiConfirm from './ai-confirm';
import AiInput from './ai-input/ai-input.vue';
import AiInputGroup from './ai-input-group/ai-input-group.vue';
import AiImageButton from './ai-image-button/ai-image-button.vue';
import AiImageUpload from './ai-image-upload/ai-image-upload.vue';
import AiDialog from './ai-dialog/ai-dialog.vue';
import AiPagination from './ai-pagination/ai-pagination.vue';
import AiVideoUpload from './videoupload/video-upload.vue';
import FileUpload from './videoupload/file-upload.vue';
import TestPlane from './videoupload/test-plane.vue';
import EditPlane from '../../views/alignment/cutedit-plane.vue';

export default {
  install(Vue) {
    // register components
    Vue.component('AiDialog', AiDialog);
    Vue.component('AiImageButton', AiImageButton);
    Vue.component('AiInput', AiInput);
    Vue.component('AiImageUpload', AiImageUpload);
    Vue.component('AiInputGroup', AiInputGroup);
    Vue.component('AiPagination', AiPagination);
    Vue.component('AiVideoUpload', AiVideoUpload);
    Vue.component('FileUpload', FileUpload);
    Vue.component('TestPlane', TestPlane);
    Vue.component('EditPlane', EditPlane);
    // register prototypes
    Vue.prototype.$message = AiMessage;
    Vue.prototype.$confirm = AiConfirm;
  },
};

export {
  AiMessage,
  AiConfirm,
  AiImageButton,
  AiImageUpload,
  AiInput,
  AiInputGroup,
  AiDialog,
  AiPagination,
};
